import { Monitor, Fingerprint, BookOpen, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const services = [
  {
    icon: Fingerprint,
    title: "Logo Design",
    body: "A mark that earns its place on everything you touch. Distinctive, versatile, and built from a real understanding of your business.",
    span: "md:col-span-4",
  },
  {
    icon: Monitor,
    title: "Websites",
    body: "Hand-built, fast, and conversion-focused. No bloated page builders — clean sites that look expensive because they are considered.",
    span: "md:col-span-4",
  },
  {
    icon: BookOpen,
    title: "Flyers & Brochures",
    body: "Print that people keep. Sharp layouts and confident typography for flyers, brochures, and everything in between.",
    span: "md:col-span-4",
  },
];

export const Services = () => (
  <section id="services" className="py-24 md:py-36 bg-white border-y border-border" data-testid="services-section">
    <div className="max-w-[1440px] mx-auto px-6 md:px-12">
      <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16 md:mb-24">
        <div>
          <p className="text-xs md:text-sm uppercase tracking-[0.25em] text-muted-foreground font-medium mb-4">
            Services
          </p>
          <h2 className="font-syne font-bold tracking-tight text-4xl sm:text-5xl">
            Three crafts.<br className="hidden md:block" /> One standard.
          </h2>
        </div>
        <p className="max-w-sm text-base text-muted-foreground font-light leading-relaxed">
          One studio for your logo, your website, and your print. No hand-offs, no agencies subcontracting agencies.
        </p>
      </Reveal>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
        {services.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.06} className={s.span}>
            <div
              className="group border border-border p-8 md:p-10 h-full hover:bg-foreground hover:text-white transition-colors duration-500 cursor-default"
              data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            >
              <div className="flex items-start justify-between mb-10 md:mb-14">
                <s.icon size={28} strokeWidth={1.5} className="text-primary group-hover:text-white transition-colors duration-500" />
                <ArrowUpRight
                  size={20}
                  className="opacity-0 -translate-x-1 translate-y-1 group-hover:opacity-100 group-hover:translate-x-0 group-hover:translate-y-0 transition-all duration-500"
                />
              </div>
              <h3 className="font-syne font-semibold text-2xl tracking-tight mb-3">{s.title}</h3>
              <p className="text-base text-muted-foreground group-hover:text-white/70 font-light leading-relaxed transition-colors duration-500">
                {s.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
